import { required, minLength } from 'vuelidate/lib/validators'

// import Foerderung from './Foerderung'

export default {
  organisationseinheit: {
    name: { required, minLength: minLength(1) }
  },
  titelKooperation: { required, minLength: minLength(1) },

  beginn: { required }
}



// WEBPACK FOOTER //
// ./src/validation/Kooperation.js